import m from 'moment';
import { get } from 'lodash';
import { getEpgLineUp } from 'services/api/epg/channel';
import {
  GetNodeId,
  GetEpgVersion,
  tvEverywhereEnable,
} from '../utils/getEpgParams';
import * as ACTIONS from '../actions/lineaUp';

export const setVersion = (result,cb)=>({
  type: ACTIONS.LINEA_UP_VERSION,
  result,
  cb,
})

export const setMenu = (result,cb)=>({
  type: ACTIONS.LINEA_UP_MENU,
  result,
  cb,
})
export const setLineaUp = (result, cb) => ({
  type: ACTIONS.LINEA_UP_SUCCESS,
  result,
  cb,
});



export const fetchEpgLineaUp = () => {
  const now = m().format('YYYYMMDDHH0000');
  const data = {
    date_from: now,
    date_to: now,
    quantity: 50,
    node_id: GetNodeId(),
  };

  if (GetEpgVersion() && tvEverywhereEnable()) {
    data.epg_version = GetEpgVersion();
  }

  return dispatch =>
    getEpgLineUp(data).then(resp => dispatch(setLineaUp(resp, () => 1)));
}